import React, { useEffect, useMemo } from "react"
import cal from "clsx"
import { renderRoutes, RouteConfig } from "react-router-config"
import Container from "@material-ui/core/Container"
import { SideDrawer } from "Components/Side"
import TopBar from "Components/TopBar"
import Copyright from "Components/Copyright"
import Message from "Components/Message"
import Alert from "Components/Alert"
import Modal from "Components/Modal"
import { useAssign, useMark, useSwitch } from "Hooks/basic"
import { usePickUserLandingPage } from "./hooks"
import {
    InitialAppMessage, InitialAppModal,
} from "./constant"
import { AppProvider } from "./context"
import { useHomeStyles } from "./style"
import { parseUserInfo, redirectLogin } from "Methods/user"
import { AppMessage, AppModal, AppModalSimple } from "Types/app"
import { Menu } from "Types/menu"
import { useFetchWeChatChannel } from "Hooks/channel"

export default ({ route }: RouteConfig) => {
    const classes = useHomeStyles()
    const { open: drawerOpen, toggle: toggleDrawer } = useSwitch(false)
    const { fetchUser, user } = usePickUserLandingPage()
    const { fetchWeChatChannel, weChatChannel } = useFetchWeChatChannel()
    const { object: appMessage, handleChange: handleChangeMessage } = useAssign<AppMessage>(InitialAppMessage)
    const { object: appModal, handleChange: handleChangeModal } = useAssign<AppModal>(InitialAppModal)
    const { object: appModalSimple, handleChange: handleChangeModalSimple } = useAssign<AppModalSimple>(InitialAppModal)
    const { mark: activeMenu, handleChangeMark: handleChangeActiveMenu } = useMark<Menu | null>(null)
    useEffect(() => {
        fetchUser()
        fetchWeChatChannel()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        // 用户被删除
        if (user && user.hidden) return redirectLogin()

    }, [user])

    const { mainList, privilegeMap, roleMap } = useMemo(
        () => parseUserInfo(user),
        [user],
    )
    return (
        <AppProvider value={{
            drawerOpen, toggleDrawer,
            user, mainList, privilegeMap, roleMap,
            appMessage, handleChangeMessage,
            appModal, handleChangeModal,
            appModalSimple, handleChangeModalSimple,
            activeMenu, handleChangeActiveMenu,
            weChatChannel,
        }}>
            <TopBar />
            <SideDrawer />
            <main
                id="content"
                className={cal(
                    classes.content,
                    drawerOpen && classes.contentShift,
                )}>
                <Container maxWidth={false} className={classes.container}>
                    {renderRoutes(route.routes)}
                </Container>
                <Copyright />
            </main>
            <Message />
            <Alert />
            <Modal />
        </AppProvider>
    )
}
